/**
 * =========================================================
 * Levels Motion™
 * Module: Magnetic Buttons
 * Version: 1.0.0
 *
 * Developed by Levels
 * https://www.levels.co.nz
 *
 * Premium motion and interaction library
 * for Shopify themes.
 *
 * Copyright © Levels. All rights reserved.
 * =========================================================
 */

document.addEventListener('DOMContentLoaded', () => {

  const buttons = document.querySelectorAll('.levels-magnetic');

  if (!buttons.length) return;

  // Disable on touch devices
  if (window.matchMedia("(pointer: coarse)").matches) return;

  buttons.forEach((button) => {

    button.addEventListener('mousemove', (event) => {

      const rect = button.getBoundingClientRect();

      const x = event.clientX - rect.left - rect.width / 2;
      const y = event.clientY - rect.top - rect.height / 2;

      const strength = 0.18;

      button.style.transform =
        `translate(${x * strength}px, ${y * strength}px)`;

    });

    button.addEventListener('mouseleave', () => {

      button.style.transform = '';

    });

  });

});